import React, { useState, useEffect, useRef, useContext, useMemo } from 'react'; 

import { useStepContext } from "../utils/StepContext.jsx"
import { useFormContext } from "../utils/FormContext.jsx"
import { AddressValueContext } from "../utils/AddressContext.jsx";
import { useAuth } from '../utils/AuthContext/AuthContext.jsx';

import MainCard from "./MainCard.jsx";
import ProgressBar from './ProgressBar/ProgressBar.jsx';
import SaveButton from './SaveButton.jsx';
import PDFPreview from './PDFPreview.jsx';
import HelpButton from './HelpButton.jsx';
import ShishitoAssist from './ShishitoAssist/ShishitoAssist.jsx';
import { useMediaQuery } from 'react-responsive';

const SellersCard = () => {

    const { handleNext, handleBack } = useStepContext();
    const { formData, handleInputChange, handleAddressChange, formId, propertyData } = useFormContext(); 
    const { searchAddress, setSearchAddress } = useContext(AddressValueContext); // Use inputValue and setInputValue from AddressValueContext
    const autocompleteInputRef = useRef(null);
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const { token, user } = useAuth();
    const [isAssistVisible, setIsAssistVisible] = useState(false);

    const currentPageValue = 0;
    const currentSubStepProgress = 2/5; 

    // console.log("Sellers Card Rendered:", propertyData);

    const [errors, setErrors] = useState({
        owner1FullName: false, 
        listingAgentEmail: false
    }); 

    const seller1NameRef = useRef(null); 

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      }; 

    // Validate inputs
    const validateFields = () => {
        const newErrors = {};
        newErrors.owner1FullName = !seller1NameRef.current?.value;  // true if empty
        newErrors.listingAgentEmail = formData.listingAgentEmail && !isValidEmail(formData.listingAgentEmail);
        setErrors(newErrors);

        // Proceed only if all fields are filled
        return !newErrors.owner1FullName && !newErrors.listingAgentEmail;
    };

    const onNext = () => {
        if (validateFields()) {
            handleNext();
        } else {
            alert("Please enter valid names in all required fields.");
        }
    };

    const toggleAssist = () => {
        setIsAssistVisible(!isAssistVisible);
    };

    const handleEmailChange = (e) => {
        handleInputChange(e);
        setErrors((prevErrors) => ({
            ...prevErrors,
            listingAgentEmail: e.target.value && !isValidEmail(e.target.value),
        }));
    };

    // console.log("Sellers Card Rendered:", propertyData, formData);

    return (
        <div className="w-full flex flex-col items-center">
            {/* <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress}/> */}
            <div className="w-full justify-start items-center flex flex-col">
                <MainCard width={750} maxHeight={450} gap={0}>
                <div className="overflow-y-auto md:max-h-[425px] max-h-[45vh] w-full">
                    <div className='inline-flex justify-between items-center w-full mb-5'>
                        {isMobile ? <h3 className="text-black text-[18px] text-left font-normal font-['Inter']">Sellers info</h3> : <h3 className="text-black text-xl text-left font-normal font-['Inter']">Validate or provide sellers information</h3>}
                        <div className='h-auto gap-2 md:gap-4 items-center inline-flex'>
                            <HelpButton onClick={toggleAssist}/>
                            <SaveButton formData={formData} formId={formId}/>
                            {user && <PDFPreview formData={formData}/>}
                        </div>
                    </div>
                    <div className="w-[350px] md:w-[600px] justify-between gap-2 items-start flex mb-4 flex-col">
                        <span className='text-sm text-slate-600'>
                            Seller 1 Full Name
                        </span>
                        <input 
                            type="text"
                            name="seller1Name"
                            placeholder="Seller 1 Name *" 
                            className={`py-1 px-3 h-[39px] rounded-md border ${errors.owner1FullName ? 'border-red-500 bg-red-100' : 'border-slate-300'} border-slate-300 w-full`} 
                            value={formData?.seller1Name ? formData.seller1Name : propertyData?.propertyDetails?.realieData?.property?.ownerName || undefined}
                            onChange={handleInputChange}
                            ref={seller1NameRef}
                            required
                        >    
                        </input>
                    </div>
                    {/* {propertyData?.data?.ownerInfo?.owner2FullName && ( */}
                    <div className="w-[350px] md:w-[600px] justify-between gap-2 items-start mb-4 flex flex-col">
                        <span className='text-sm text-slate-600'>
                            Seller 2 Full Name
                        </span>
                        <span className='text-[11px] text-slate-600'>
                            *Required if there are 2 seller's on the current mortgage
                        </span>
                        <input 
                            type="text"
                            name="seller2Name"
                            placeholder="Seller 2 Name" 
                            className={`py-1 px-3 h-[39px] rounded-md border border-slate-300 w-full`}
                            // value={formData.seller2Name}
                            value={formData?.seller2Name !== undefined ? formData.seller2Name : propertyData?.data?.ownerInfo?.owner2FullName ? propertyData?.data?.ownerInfo?.owner2FullName : "" || undefined}
                            onChange={handleInputChange}
                            
                        >    
                        </input>
                    </div>
                    {/* )} */}

                    {/* {propertyData?.data?.mlsHistory?.length > 0 && ( */}
                    <>
                    <div className="w-[350px] md:w-[600px] justify-between gap-2 items-start mb-4 flex flex-col">
                        <span className='text-sm text-slate-600'>
                            Listing Agent Name
                        </span>
                        <input 
                            type="text"
                            name="listingAgentName"
                            placeholder="Agent Name" 
                            className={`py-1 px-3 h-[39px] rounded-md border border-slate-200 w-full`} 
                            // value={formData.listingAgentName}
                            value={formData?.listingAgentName ? formData?.listingAgentName : propertyData?.propertyDetails?.attributionInfo?.agentName || undefined}
                            onChange={handleInputChange}
                            
                        >    
                        </input>
                    </div>
                    
                    <div className="w-[350px] md:w-[600px] justify-between gap-2 items-start flex flex-col mb-4">
                        <div className="relative flex flex-col mt-2 w-full border rounded-md border-slate-400 p-5">
                            <span className="absolute -top-2 left-2 bg-white px-1 text-[12px] md:text-sm font-[Inter] text-slate-700"><b className='text-black'><i>Recommended</i></b></span>
                            <div className='flex flex-col gap-1'>
                                <span className='text-sm text-slate-600'>Listing Agent Email</span>
                                <span className='text-[12px] font-bold text-shi-purple mb-2'>
                                    To send an e-signature to the seller's agent after you sign, please provide the listing agent email and Shishito can manage the entire signature process for you.
                                </span>                        
                            </div>
                            <input 
                                type="text"
                                name="listingAgentEmail"
                                placeholder="Email *" 
                                className={`py-1 px-3 h-[39px] rounded-md border border-slate-200 w-full`} 
                                value={formData?.listingAgentEmail ? formData?.listingAgentEmail : propertyData?.propertyDetails?.attributionInfo?.agentEmail || undefined}
                                onChange={handleEmailChange}
                                
                            />    
                            {errors.listingAgentEmail && (
                                <span className="text-red-500 text-[13px] mt-1">
                                    Please input a valid email address.
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="w-[350px] md:w-[600px] justify-between gap-2 items-start flex flex-col">
                        <span className='text-sm text-slate-600'>
                            Listing Agent Phone
                        </span>
                        <input 
                            type="text"
                            name="listingAgentPhone"
                            placeholder="Phone" 
                            className={`py-1 px-3 h-[39px] rounded-md border border-slate-200 w-full`} 
                            // value={formData.listingAgentPhone}
                            value={formData?.listingAgentPhone ? formData?.listingAgentPhone : propertyData?.propertyDetails?.attributionInfo?.agentPhoneNumber || undefined}
                            onChange={handleInputChange}
                            
                        >    
                        </input>
                    </div>
                    </>
                    {/* )} */}
                </div>

                    <div className="flex w-full justify-center gap-10 md:gap-36 mt-2 bg-white">
                        <button className="w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-center md:items-start flex" onClick={handleBack}>
                            Back
                        </button>
                        <button className="w-[100px] md:w-[150px] justify-center items-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 md:items-start flex" onClick={onNext}>
                            Next
                        </button>
                    </div>
                </MainCard>
                {isAssistVisible && (
                <div className="w-full md:w-auto absolute bottom-1 md:right-4">
                    <ShishitoAssist onClose={toggleAssist}/>
                </div>
            )}
            </div>
        </div>
    )
}

export default SellersCard; 